import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import ServicesLanding from "../views/ServicesLanding";
import IctConsultancy from "../views/IctConsultancy";
import ProjectManagement from "../views/ProjectManagement";
import SoftwareDevelopment from "../views/SoftwareDevelopment";
import NetworkInfrastructure from "../views/NetworkInfrastructure";
import HardwareSupport from "../views/HardwareSupport";
import ManagedServices from "../views/ManagedServices";
import UnifiedCommunication from "../views/UnifiedCommunication";
import IctCctv from "../views/IctCctv";
import IndustrialChemicals from "../views/IndustrialChemicals";



export default function Services(props) {

	const appContext = useContext(AppContext);

	const [ view, setView ] = useState(null);

	async function init() {
		//run initializations here
	}

	function getView() {
		if(
			!appContext.navSubItem &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <ServicesLanding/>
		} else if(
			appContext.navSubItem === 'ICT_consultancy' &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <IctConsultancy/>
		} else if(
			appContext.navSubItem === 'software_development' &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <SoftwareDevelopment/>
		} else if(
			appContext.navSubItem === 'network&infrastructure' &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <NetworkInfrastructure/>
		} else if(
			appContext.navSubItem === 'hardware&support' &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <HardwareSupport/>
		} else if(
			appContext.navSubItem === 'managed_services' &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <ManagedServices/>
		} else if(
			appContext.navSubItem === 'unified_communication' &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <UnifiedCommunication/>
		} else if(
			appContext.navSubItem === 'project_management' &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <ProjectManagement/>
		} else if(
			appContext.navSubItem === 'ict_cctv' &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <IctCctv/>
		} else if(
			appContext.navSubItem === 'industrial_chemicals' &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <IndustrialChemicals/>
		} 

		return null;
	}

	useEffect(() => {
		init();
	}, [ ])

	useEffect(() => {
		const _view = getView();
		if(_view) {
			setView(_view);
		}
	}, [ appContext.navSubItem, appContext.navExtraItem, appContext.navMoreItem ])

	//return desired view
	return view;
}